import { useSearchParams } from 'react-router-dom';

// Links opened from a Quality Task carry ?qt=<task_id>; pages then show only the assigned simulation
export const withAssignment = (link, taskId) => `${link}${link.includes('?') ? '&' : '?'}qt=${taskId}`;

export const useAssignedTask = () => useSearchParams()[0].get('qt');
